/**
 * PANEL-AUFNAHMEN MIT html2canvas NACH DEM TAG/NACHT-UMBAU (03.10.2026).
 *
 * html2canvas 1.4 versteht nur #hex, rgb(), hsl() und Farbnamen. Seit dem Tag/Nacht-Umschalter
 * stehen in der Oberflaeche CSS-Variablen und color-mix(); deren berechneter Wert ist
 * `color(srgb …)` — daran bricht html2canvas mit „unsupported color function" ab und die
 * ganze Aufnahme scheitert. Dasselbe gilt fuer oklch()/oklab() aus Tailwind 4.
 * Deshalb: im geklonten Dokument jede solche Farbe vorher in rgba() umrechnen (onclone),
 * und als Hintergrund die tatsaechlich gezeichnete Farbe statt `var(--tn-bg)` uebergeben.
 */

const FARB_EIGENSCHAFTEN = [
  'color', 'background-color', 'border-top-color', 'border-right-color', 'border-bottom-color',
  'border-left-color', 'outline-color', 'text-decoration-color', 'column-rule-color', 'caret-color',
  'fill', 'stroke', 'box-shadow', 'text-shadow', 'background-image',
] as const;
const UNBEKANNT = /(color|oklch|oklab|lab|lch|hwb)\(/;
const FUNKTION = /(color|oklch|oklab|lab|lch|hwb)\((?:[^()]|\([^()]*\))*\)/g;

let pinsel: CanvasRenderingContext2D | null = null;

/** Rechnet eine beliebige CSS-Farbe ueber einen 1x1-Canvas in rgba() um. */
export function alsRgba(farbe: string): string {
  if (!pinsel) {
    const c = document.createElement('canvas'); c.width = 1; c.height = 1;
    pinsel = c.getContext('2d', { willReadFrequently: true });
    if (!pinsel) throw new Error('[aufnahmeFarben] Kein 2D-Canvas verfuegbar — Farben koennen nicht umgerechnet werden.');
  }
  pinsel.clearRect(0, 0, 1, 1);
  pinsel.fillStyle = '#000';
  pinsel.fillStyle = farbe;
  pinsel.fillRect(0, 0, 1, 1);
  const [r, g, b, a] = pinsel.getImageData(0, 0, 1, 1).data;
  return a === 255 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${Math.round((a / 255) * 1000) / 1000})`;
}

/** onclone fuer html2canvas: alle neuen Farbfunktionen im Klon durch rgba() ersetzen. */
export function farbenFuerHtml2canvas(klon: Document): void {
  const fenster = klon.defaultView;
  if (!fenster) return;
  for (const el of Array.from(klon.querySelectorAll<HTMLElement | SVGElement>('*'))) {
    const cs = fenster.getComputedStyle(el);
    for (const name of FARB_EIGENSCHAFTEN) {
      const wert = cs.getPropertyValue(name);
      if (!wert || !UNBEKANNT.test(wert)) continue;
      el.style.setProperty(name, wert.replace(FUNKTION, f => alsRgba(f)), 'important');
    }
  }
}

/** Hintergrund der Aufnahme: die gerade gezeichnete Seitenfarbe (folgt Tag/Nacht), als rgb(). */
export function aufnahmeHintergrund(): string {
  return alsRgba(getComputedStyle(document.body).backgroundColor || '#1a1b26');
}
